const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20young%20person%20warm%20lighting%20neutral%20background%20clean%20minimal%20style&width=80&height=80&seq=avatar-cmt-01&orientation=squarish',
    name: '光影追梦人',
    time: '2小时前',
    content: '大师兄影视的画质真的没话说，4K修复版《霸王别姬》每一帧都是壁纸级别的。最让我惊喜的是加载速度，点击即播，完全没有缓冲等待，观影体验太流畅了！',
    likes: 326,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20adult%20warm%20lighting%20neutral%20background%20clean%20minimal%20style&width=80&height=80&seq=avatar-cmt-02&orientation=squarish',
    name: '剧荒终结者',
    time: '5小时前',
    content: '作为一个追剧狂魔，大师兄影视简直是救星！片库太全了，从最新热播剧到冷门纪录片都有。综艺更新也特别准时，再也不用到处找资源了。',
    likes: 258,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20young%20adult%20warm%20lighting%20neutral%20background%20clean%20minimal%20style&width=80&height=80&seq=avatar-cmt-03&orientation=squarish',
    name: '电影发烧友阿杰',
    time: '8小时前',
    content: '用大师兄影视三年了，从追《狂飙》到看《长安十二时辰》，片源质量和更新速度一直稳定在线。多设备续播功能也很实用，通勤手机看、回家电视接着看。',
    likes: 189,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="relative py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-50 mb-3">影迷口碑</h2>
          <p className="text-foreground-500 max-w-lg mx-auto">真实用户评价，看看大家都在说什么</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((cmt, idx) => (
            <div key={idx} className="bg-background-200/50 rounded-xl p-6 border border-background-200/60">
              <div className="flex items-center gap-3 mb-4">
                <img src={cmt.avatar} alt={cmt.name} className="w-10 h-10 rounded-full object-cover" loading="lazy" />
                <div>
                  <div className="text-sm font-semibold text-foreground-200">{cmt.name}</div>
                  <div className="text-xs text-foreground-600">{cmt.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-4">{cmt.content}</p>
              <div className="flex items-center gap-1 text-foreground-600 text-xs">
                <i className="ri-heart-line text-accent-500"></i>
                <span>{cmt.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}